import { LooseObject } from "./loose-object.model";

export interface UserMetricsInterface {
  userId: string | null;
  accountId: string | null;
  platform?: 'ADA';
  pageVisits: LooseObject;
  simulationCount: number;
  sensitivityCount: number;
  scenarioComparisonCount: number;
  saveCount: number;
  saveSensitivityCount: number;
  saveScenarioComparisonCount: number;
  timeSpentLoggedIn: number;
}

export class UserMetrics {
  userId: string | null = null;
  accountId: string | null = null;
  platform = 'ADA';
  pageVisits: LooseObject = {};
  simulationCount = 0;
  sensitivityCount = 0;
  scenarioComparisonCount = 0;
  saveCount = 0;
  saveSensitivityCount = 0;
  saveScenarioComparisonCount = 0;
  timeSpentLoggedIn = 0;

  constructor(param: UserMetricsInterface = {
    userId: null,
    accountId: null,
    pageVisits: {},
    simulationCount: 0,
    sensitivityCount: 0,
    scenarioComparisonCount: 0,
    saveCount: 0,
    saveSensitivityCount: 0,
    saveScenarioComparisonCount: 0,
    timeSpentLoggedIn: 0,
  }) {
    if (param) {
      this.userId = param.userId;
      this.accountId = param.accountId;
      this.pageVisits = {};
      if (param.pageVisits) {
        for (const key of Object.keys(param.pageVisits)) {
          this.pageVisits[key] = param.pageVisits[key];
        }
      }
      this.simulationCount = param.simulationCount;
      this.sensitivityCount = param.sensitivityCount;
      this.scenarioComparisonCount = param.scenarioComparisonCount;
      this.saveCount = param.saveCount;
      this.saveSensitivityCount = param.saveSensitivityCount;
      this.saveScenarioComparisonCount = param.saveScenarioComparisonCount;
      this.timeSpentLoggedIn = param.timeSpentLoggedIn;
    }
  }
}
